<template>
  <v-container class="d-flex flex-column h-100 pa-5" style="max-width: 450px;">
    <section class="fill-height flex-fill d-flex align-center justify-center">
      <div v-if="loading" class="text-center">
        <h2>
          Ingresando a su atención
        </h2>
        <h4
          style="font-weight: 100"
          class="text--secondary mb-3"
        >
          Por favor espere...  🤝
        </h4>
        <v-progress-linear
          indeterminate
          color="primary"
        ></v-progress-linear>
      </div>
      <div v-else-if="widget" style="width: 100%;">
        <Avatar v-if="widget.banner" :src="widget.banner" :size="100" class="mb-5" />
        <section v-html="widget.title" class="mb-2"></section>
        <section v-html="widget.description" class="mb-5"></section>
        <Form
          v-if="widget.questionnary"
          :categoryCode="categoryCode"
          :userCode="userCode"
          :questionnary="widget.questionnary"
          @submit="onSubmit"
          :loading="entering"
          :color="widget.primaryColor"
        />
      </div>
      <div v-else>
        <EmptyLink />
      </div>
    </section>
    <footer class="d-flex justify-center">
      <OcularSign />
      <Logo :style="{ width: '60px' }" />
    </footer>
  </v-container>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'
import MainService from '@/services/MainService'
import widget from '@/services/Widget'
import Form from './resources/Form.vue'

require('@/services/SessionLink')

@Component({
  components: {
    EmptyLink: () => import(/* webpackPrefetch: true */ '@/views/magic-link/resources/EmptyLink.vue'),
    Form: () => import(/* webpackPrefetch: true */ '@/views/magic-link/resources/Form.vue'),
    OcularSign: () => import(/* webpackPrefetch: true */ '@/components/OcularSign.vue'),
    Avatar: () => import('@/components/ui/Avatar.vue'),
    Logo: () => import('@/components/Logo.vue'),
  }
})

export default class Index extends Vue {
  data () {
    return {
      verifyMagicLink: false,
      loading: false,
      entering: false,
      categoryCode: null,
      userCode: null,
      widget: null
    }
  }

  async mounted () {
    this.categoryCode = this.$route.params.categoryCode

    if (this.$route.params.userCode) {
      this.userCode = this.$route.params.userCode
    }

    await this.verifyCode()
  }


  async onSubmit (data) {
    this.entering = true

    const customer = {}
    data.forEach((item) => {
      customer[item.reference] = item.answer
    })

    const params = {
      categoryCode: this.categoryCode,
      userCode: this.userCode,
      customer
    }

    return this.$sessionLink.generateWidgetSessionLinkByCategory(params)
      .then((response) => {
        const res = response.data

        if (res.statusCode === 0 && res.data.link) {
          const link = res.data.link
          window.location.href = link
        } else {
          this.entering = false
        }
      })
      .catch((e) => {
        console.log(e)
        this.entering = false
      })
  }

  async verifyCode () {
    this.loading = true

    const data = {
      route: '/magic/link/code',
      params: {
        categoryCode: this.categoryCode
      }
    }

    if (this.userCode) {
      data.params.userCode = this.userCode
    }

    return MainService.get(data)
      .then((response) => {
        this.widget = response.data
        this.verifyMagicLink = true
        this.$store.state.parentLocation.organizationCode = this.widget.code
        this.$store.state.parentLocation.origin = this.widget.hostname
      })
      .finally(() => {
        this.loading = false
      })
  }
}
</script>